import ReactDOM from 'react-dom/client';

import App from './App/App';
import './coralogix';

ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
